import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";


const listGradeType= async (page : number , pageSize : number , activity_id : string , grade_id: string, sort : string , order: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/grade/list_activity_config?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&status=active,inactive&keyword=&activity_type=${activity_id}&grade_id=${grade_id}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listGradeOptions= async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/grade/list?sort=&order=desc&status=active,inactive&keyword=`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }


  const changeGradeStatus = async (id: string, status: string, interface_name : string) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/grade/change_status`, {
        id: id,
        status: status,
        interface_name: interface_name
      },
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const addGradeType = async (dataToSend:any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/grade/add_activity_config`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }


  const getActivityList = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master/list_all_activities?status=active`, {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }


  const getUOMList = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master/list_all_unit_of_measurement?status=active`, {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const getGradeById= async (id: any) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/grade/list?sort=&order=desc&status=active,inactive&keyword=&id=${id}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }


  const listPersonnelLocList= async (page : number , pageSize : number , keyword: any, sort : string , order: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/finger_dab_option/list_finger_dab_option?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&keyword=${keyword}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  
  const addPersonnelMonitoringLoc = async (dataToSend:any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/finger_dab_option/save_finger_dab_option`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const changePersonnelLocationStatus = async (id: string, status: string, interface_name : string) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/finger_dab_option/change_finger_dab_status`, {
        id: id,
        status: status,
        interface_name: interface_name
      },
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const gradeTypes = {
    listGradeType,
    changeGradeStatus,
    addGradeType,
    getActivityList,
    getUOMList,
    getGradeById,
    listGradeOptions,
    listPersonnelLocList,
    addPersonnelMonitoringLoc,
    changePersonnelLocationStatus
};
  
  
export { gradeTypes };